var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduledFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.3 65.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M24.49 1.5a4.56 4.56 0 0 1 2.61 2l16.42 20.24c1.62 2 1.62 1.93 4.18 2 3.69.16 7.38.31 11 .7a10.64 10.64 0 0 1 7.39 4.31A3.3 3.3 0 0 1 66 35a11.46 11.46 0 0 1-8.23 4.25c-3.75.24-7.5.39-11.25.53a2.86 2.86 0 0 0-2.31 1.2Q36 51.18 27.67 61.38c-2.47 3-2.74 2.84-6.6 2.47a3.5 3.5 0 0 1-1.07-.33 1.58 1.58 0 0 1-1.07-2c.53-2 1.13-3.91 1.75-5.84 1.64-5.1 3.31-10.19 5-15.28a5 5 0 0 0 .12-.45h-9.45a2.57 2.57 0 0 0-2.21 1c-1.9 2.29-3.85 4.53-5.79 6.79-.42.49-.87 1-1.33 1.42a3.4 3.4 0 0 1-4 .66A2 2 0 0 1 1.59 47c.32-1.42.72-2.81 1.09-4.22.79-3 1.62-6.08 2.37-9.13a3.9 3.9 0 0 0 0-1.83C4 27.66 2.87 23.48 1.77 19.29c-.66-2.57.17-3.65 3-3.77a2.8 2.8 0 0 1 2.3 1l5.18 6c.75.87 1.46 1.76 2.26 2.57a1.83 1.83 0 0 0 1.16.5h10.07c-.13-.45-.25-.85-.38-1.25q-3-9.33-6-18.68A9 9 0 0 1 19 3.42a1.4 1.4 0 0 1 1.21-1.54c.62-.16 1.26-.26 1.9-.38z",
    "data-name": "Layer 22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduledFlight);
export default __webpack_public_path__ + "static/media/scheduledFlight.64059d1c3e6f6f858384314d49b458ef.svg";
export { ForwardRef as ReactComponent };